import { useTranslation } from 'react-i18next'
type PrivacyActNoticeProps = {
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}
export function PrivacyActNotice ({ headingLevel }: PrivacyActNoticeProps) {
  const { t } = useTranslation('easyPayCommon')

  const HeadingTag = headingLevel ?? 'h3'

  return (
    <div>
      <HeadingTag className="ds-text-body--sm ds-u-font-weight--bold">
        {t('privacyAct.heading')}
      </HeadingTag>
      <div className="ds-text-body--sm ds-u-margin-top--1">
        {t('privacyAct.content')}
      </div>
    </div>
  )
}

export default PrivacyActNotice
